import { Toggle } from '..';

import cn from 'classnames';
import { Collapse } from 'react-bootstrap';

import { Button } from 'components/FormComponents';
import StatusPill from 'components/Pills/StatusPills';
import { TitleGroup } from 'components/TitleGroup/TitleGroup';

import styles from './ToggleSwitchInput.module.scss';

export const ToggleSwitchInput = ({
  text,
  subtext,
  name,
  value,
  className,
  children,
  headerChildren,
  cardClassName,
  icon,
  noMaxWidth = false,
  dataTestId,
  toggle = true,
  status,
  statusText,
  toggleReplacementButtonText,
  onToggleReplacementButton,
  toggleReplacementButtonType = 'primary',
  onChange = () => {},
}) => {
  return (
    <div
      className={cn(
        styles.root,
        'border border-neutral-4 rounded-3xl shadow-sm p-8 bg-neutral-1 flex flex-col gap-8 w-full',
        {
          [className]: className,
          [styles.noMaxWidth]: noMaxWidth,
        },
      )}>
      <div
        className={cn('w-full', 'rounded-3xl', {
          [cardClassName]: cardClassName,
        })}>
        <div className="d-flex flex-column u-width-100">
          <div
            className={cn(
              styles.input,
              'u-width-100',
              'd-flex',
              'align-items-center',
              'justify-content-between',
            )}>
            <div className="w-3/4">
              <TitleGroup icon={icon} title={text} subTitle={subtext} />
            </div>
            {toggle && !toggleReplacementButtonText && (
              <Toggle
                inputProps={{ name, checked: value, onChange }}
                dataTestId={dataTestId}
                small
              />
            )}
            {toggleReplacementButtonText && (
              <Button small onClick={onToggleReplacementButton} type={toggleReplacementButtonType}>
                {toggleReplacementButtonText}
              </Button>
            )}
            {status && !toggle && <StatusPill text={statusText} status={status} />}
          </div>
          {headerChildren && (
            <>
              <div className="u-divider" />
              <div className="u-margin-left--small">{headerChildren}</div>
            </>
          )}
        </div>
        <Collapse in={children && value} className="u-width-100">
          <div>
            <div className={cn(styles.content)}>{children}</div>
          </div>
        </Collapse>
      </div>
    </div>
  );
};
